import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission and send data to the backend
  const showMessage = async (e) => {
    e.preventDefault();
    try {
      // Sending form data to the backend API
      const response = await fetch("http://localhost:5006/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.success) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" }); // Reset form data
      } else {
        alert("Failed to send the message. Please try again!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <section id="contact" className="py-5 bg-dark text-white text-center">
      <div className="containerr">
        <h2 className="display-6 fw-bold mb-4">Contact Me</h2>
        <form className="row g-3 justify-content-center" onSubmit={showMessage}>
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-12">
            <textarea
              className="form-control"
              rows="5"
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="col-12">
            <button
              type="submit"
              className="btn btn-success btn-lg transform transition-transform duration-200 active:scale-95 active:shadow-md"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>

      <br />
      <div className="social-links">
        <a href="https://www.linkedin.com/in/tushar-singha-35a6b1334/" className="hover:text-green-400">LinkedIn</a> | 
        <a href="https://github.com/Myself-Tushar" className="hover:text-green-400">GitHub</a> | 
        <a href="https://x.com/Tech_TSR" className="hover:text-green-400">Twitter</a>
      </div>

      <p className="footer-text">© 2024 Tech TSR. All rights reserved.</p>
    </section>
  );
}

export default Contact;
